import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PatientService from "../services/PatientService";
import BloodTypeService from "../services/BloodTypeService";

function PatientForm() {
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [height, setHeight] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [lbo, setLbo] = useState("");
  const [medicalNote, setMedicalNote] = useState("");
  
  // Nova polja
  const [allergies, setAllergies] = useState("");
  const [surgeries, setSurgeries] = useState("");
  const [otherInfo, setOtherInfo] = useState("");
  
  const [bloodTypes, setBloodTypes] = useState([]);
  const [bloodTypeID, setBloodTypeID] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const loadBloodTypes = async () => {
      try {
        const data = await BloodTypeService.getAllBloodTypes();
        setBloodTypes(data);
      } catch (err) {
        setError("Neuspešno učitavanje krvnih grupa.");
      }
    };
    loadBloodTypes();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // VAŽNO: Payload mora sadržati SVA polja koja PatientDTO na backendu zahteva
    const newPatient = { 
      name, 
      surname, 
      email, 
      phone,
      height: height ? parseFloat(height) : 0,
      birthDate,
      lbo,
      medicalNote,
      allergies, 
      surgeries, 
      otherInfo,
      bloodType: { bloodID: parseInt(bloodTypeID) } 
    };

    try {
      await PatientService.create(newPatient);
      navigate("/patients");
    } catch (error) {
      console.error("Error:", error);
      setError(`Greška: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <div className="container mt-4 mb-5" style={{ maxWidth: "800px" }}>
      <div className="card shadow-sm p-4">
        <h2 className="mb-4 text-primary">Novi Pacijent</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            {/* Osnovne informacije */}
            <div className="col-md-6">
              <label className="form-label">Ime</label>
              <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
            </div>
            <div className="col-md-6">
              <label className="form-label">Prezime</label>
              <input type="text" className="form-control" value={surname} onChange={(e) => setSurname(e.target.value)} required />
            </div>
            
            <div className="col-md-6">
              <label className="form-label">Email</label>
              <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="col-md-6">
              <label className="form-label">Telefon</label>
              <input type="text" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} required />
            </div>

            <div className="col-md-4">
              <label className="form-label">Datum rođenja</label>
              <input type="date" className="form-control" value={birthDate} onChange={(e) => setBirthDate(e.target.value)} required />
            </div>
            <div className="col-md-4">
              <label className="form-label">Visina (cm)</label>
              <input type="number" className="form-control" value={height} onChange={(e) => setHeight(e.target.value)} />
            </div>
            <div className="col-md-4">
              <label className="form-label">LBO</label>
              <input type="text" className="form-control" value={lbo} onChange={(e) => setLbo(e.target.value)} required />
            </div>

            <div className="col-12">
              <label className="form-label">Krvna grupa</label>
              <select className="form-select" value={bloodTypeID} onChange={(e) => setBloodTypeID(e.target.value)} required>
                <option value="">Izaberi...</option>
                {bloodTypes.map((t) => (
                  <option key={t.bloodID} value={t.bloodID}>{t.bloodTypeName}</option>
                ))}
              </select>
            </div>

            {/* MEDICINSKI DEO (Slobodan unos) */}
            <hr className="my-4" />
            <h5 className="text-muted">Medicinska dokumentacija</h5>

            <div className="col-12">
              <label className="form-label text-danger fw-bold">Alergije ⚠️</label>
              <textarea className="form-control" rows="2" placeholder="Unesite alergije..." value={allergies} onChange={(e) => setAllergies(e.target.value)}></textarea>
            </div>

            <div className="col-12">
              <label className="form-label fw-bold">Prethodne operacije</label>
              <textarea className="form-control" rows="2" placeholder="Istorija operacija..." value={surgeries} onChange={(e) => setSurgeries(e.target.value)}></textarea>
            </div>

            <div className="col-12">
              <label className="form-label fw-bold">Opšta napomena</label>
              <textarea className="form-control" rows="2" placeholder="Glavne tegobe..." value={medicalNote} onChange={(e) => setMedicalNote(e.target.value)}></textarea>
            </div>

            <div className="col-12">
              <label className="form-label fw-bold">Ostalo (Drugo)</label>
              <textarea className="form-control" rows="2" placeholder="Dodatne info..." value={otherInfo} onChange={(e) => setOtherInfo(e.target.value)}></textarea>
            </div>
          </div>

          <div className="mt-4 d-flex gap-2">
            <button type="submit" className="btn btn-primary px-5">Sačuvaj</button>
            <button type="button" className="btn btn-outline-secondary" onClick={() => navigate("/patients")}>Odustani</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PatientForm;